/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CogRegular from './cog-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CogRegular {...validProps} />;
}

SvgComponent.iconName = 'cogRegular';

export const CogRegularIcon = svgIconWrapper(SvgComponent);
